import React, { useEffect, useState } from 'react';
import { Modal, Table, Button, InputNumber, Avatar, Tag, message } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { GetCazaAlumnos } from '../../../../dao/jutge/GetCazaAlumnos';
import { PutCazaIntentos } from '../../../../dao/jutge/PutCazaIntentos';

interface CazaAlumno {
    id_usuari: number;
    nom: string;
    email: string;
    intentos: number;
}

interface Props {
    visible: boolean;
    onClose: () => void;
    idCaza: number;
    nomCaza: string;
}

const EditAttemptsModal: React.FC<Props> = ({ visible, onClose, idCaza, nomCaza }) => {
    const [alumnos, setAlumnos] = useState<CazaAlumno[]>([]);
    const [loading, setLoading] = useState(false);
    const [editingId, setEditingId] = useState<number | null>(null);
    const [tempIntentos, setTempIntentos] = useState<number>(0);

    const fetchData = async () => {
        setLoading(true);
        const data = await GetCazaAlumnos(idCaza.toString());
        if (data) {
            setAlumnos(data);
        }
        setLoading(false);
    };

    useEffect(() => {
        if (visible) {
            fetchData();
        }
    }, [visible, idCaza]);

    const handleSave = async (record: CazaAlumno) => {
        const success = await PutCazaIntentos(idCaza.toString(), record.id_usuari.toString(), tempIntentos);
        if (success) {
            message.success("Intentos actualizados correctamente");
            setEditingId(null);
            fetchData();
        } else {
            message.error("Error al actualizar intentos");
        }
    };

    const columns: ColumnsType<CazaAlumno> = [
        {
            title: 'Alumno',
            dataIndex: 'nom',
            key: 'nom',
            render: (text, record) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <Avatar style={{ backgroundColor: '#f56a00' }}>{text.charAt(0)}</Avatar>
                    <div>
                        <div style={{ fontWeight: 'bold' }}>{text}</div>
                        <div style={{ fontSize: '0.8em', color: '#888' }}>{record.email}</div>
                    </div>
                </div>
            )
        },
        {
            title: 'Intentos Restantes',
            dataIndex: 'intentos',
            key: 'intentos',
            render: (val, record) => {
                if (editingId === record.id_usuari) {
                    return (
                        <div style={{ display: 'flex', gap: 5 }}>
                            <InputNumber
                                value={tempIntentos}
                                onChange={(v) => setTempIntentos(v || 0)}
                                min={0}
                            />
                            <Button type="primary" size="small" onClick={() => handleSave(record)}>OK</Button>
                            <Button size="small" onClick={() => setEditingId(null)}>X</Button>
                        </div>
                    );
                }
                return (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: 100 }}>
                        <Tag color={val > 0 ? "blue" : "red"}>{val}</Tag>
                        <Button
                            type="link"
                            size="small"
                            onClick={() => {
                                setEditingId(record.id_usuari);
                                setTempIntentos(val);
                            }}
                        >
                            Editar
                        </Button>
                    </div>
                );
            }
        }
    ];

    return (
        <Modal
            title={`Editar Intentos de la Píldora: ${nomCaza}`}
            open={visible}
            onCancel={onClose}
            footer={[
                <Button key="close" onClick={onClose}>Cerrar</Button>
            ]}
        >
            <Table
                dataSource={alumnos}
                columns={columns}
                rowKey="id_usuari"
                size="small"
                loading={loading}
                pagination={{ pageSize: 5 }}
            />
        </Modal>
    );
};

export default EditAttemptsModal;
